<template>
</template>

<script>
import printBOL from '@/views/sales/shipments/printBOL'

export default {
  name: 'SalesShipmentsPrintBOL',
  mixins: [printBOL],
  props: {
    shipment: {type:Object, required:true}
  },
  async created() {
    this.$emit('done');

    const results = await this.$apiCall(`query SalesShipmentsPrintBOL($id:ID!) {
                                            shipment(id:$id) {
                                              date,invoice{number},shipVia,shipToAddress,laa,draft,
                                              pallets,number,specialInstructions
                                              lines {
                                                sku,description,quantity,units,precision,weight,lot
                                                items {sku,description,quantity,units,precision,weight,lot}
                                              }
                                            }
                                            company {name,address,city,province,postalCode}
                                          }`,
                                        {id:this.shipment.id});
    if (results.error)
      return;
    const company = results.data.company;
    const shipmentObject = results.data.shipment;

    this.printBOL({shipperName:company.name,
                   shipperAddress:`${company.address}\n${company.city} ${company.province}  ${company.postalCode}`,
                   shipToAddress:shipmentObject.shipToAddress, referenceNumber:shipmentObject.number, date:shipmentObject.date,
                   shipVia:shipmentObject.shipVia, pallets:shipmentObject.pallets, specialInstructions:shipmentObject.specialInstructions,
                   laa:shipmentObject.laa,
                   lines: shipmentObject.lines});
  }
}
</script>